"use client";

import React from "react";
import MCMComboboxSuppliersOnlyExample from "@/examples/MCMComboboxSuppliersOnlyExample";

export default function MCMComboboxSuppliersOnlyExamplePage() {
  return (
    <div className="container mx-auto p-6">
      <MCMComboboxSuppliersOnlyExample />
    </div>
  );
}
